import React from "react";
import Box from "@material-ui/core/Box";
import { Container } from "@prestosports/commons-ui";
import classnames from "classnames";
import NavigationTabPanel from "../../season/components/NavigationTabPanel";
import SinglesContainer from "./SinglesContainer";
import DoublesContainer from "./DoublesContainer";
import { useEventContext } from "../../../state/events/context";
import ScoreBoardContainer from "../../game-stats/containers/ScoreBoardContainer";
import gameContainerStyles from "../styles/GameContainer.styles";

const GameContainer = () => {
	const classes = gameContainerStyles();
	const { state: events } = useEventContext();
	const currentEvent = events.currentEvent();
	const { gameConfiguration } = events.currentEventSettings();

	const getTabItems = () => {
		const tabItems = [];

		if (gameConfiguration?.singles?.numberOfMatches) {
			tabItems.push({
				label: "Singles",
				tab: "singles",
				component: <SinglesContainer event={currentEvent} />
			});
		}

		if (gameConfiguration?.doubles?.numberOfMatches) {
			tabItems.push({
				label: "Doubles",
				tab: "doubles",
				component: <DoublesContainer event={currentEvent} />
			});
		}

		return tabItems;
	};

	return (
		<>
			{currentEvent && (
				<Box className={classnames(classes.header, classes.scoreBox)}>
					<ScoreBoardContainer />
				</Box>
			)}
			<Box className={classes.container}>
				<Container fullHeight>
					<NavigationTabPanel items={getTabItems()} />
				</Container>
			</Box>
		</>
	);
};

export default GameContainer;
